import { Flex } from 'reflexbox';

import CloseIcon from 'packages/kakapo-ui-kit/assets/icons/CloseIcon';
import {
	ComposableListItemControls,
	ComposableListItemControlsButton,
} from 'packages/kakapo-ui-kit/components/lists/ComposableList';

interface IProps {
	onRemove: () => void;
}

export default function RecipientFieldControls({ onRemove }: IProps) {
	return (
		<ComposableListItemControls>
			<Flex flexDirection="row">
				<ComposableListItemControlsButton onClick={() => onRemove()}>
					<CloseIcon />
				</ComposableListItemControlsButton>
			</Flex>
		</ComposableListItemControls>
	);
}
